var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33761 3.77487C1.37535 3.73704 1.42018 3.70702 1.46954 3.68654C1.51889 3.66606 1.5718 3.65552 1.62524 3.65552C1.67867 3.65552 1.73158 3.66606 1.78094 3.68654C1.8303 3.70702 1.87513 3.73704 1.91286 3.77487L6.50024 8.36306L11.0876 3.77487C11.1254 3.7371 11.1702 3.70714 11.2196 3.68669C11.2689 3.66625 11.3218 3.65573 11.3752 3.65573C11.4287 3.65573 11.4816 3.66625 11.5309 3.68669C11.5803 3.70714 11.6251 3.7371 11.6629 3.77487C11.7006 3.81264 11.7306 3.85748 11.751 3.90683C11.7715 3.95618 11.782 4.00908 11.782 4.06249C11.782 4.11591 11.7715 4.1688 11.751 4.21816C11.7306 4.26751 11.7006 4.31235 11.6629 4.35012L6.78786 9.22512C6.75013 9.26295 6.7053 9.29297 6.65594 9.31345C6.60659 9.33393 6.55367 9.34447 6.50024 9.34447C6.4468 9.34447 6.39389 9.33393 6.34454 9.31345C6.29518 9.29297 6.25035 9.26295 6.21261 9.22512L1.33761 4.35012C1.29978 4.31238 1.26976 4.26755 1.24928 4.2182C1.2288 4.16884 1.21826 4.11593 1.21826 4.06249C1.21826 4.00906 1.2288 3.95615 1.24928 3.90679C1.26976 3.85744 1.29978 3.81261 1.33761 3.77487Z",
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIChevronDown);
export default __webpack_public_path__ + "static/media/i-chevronDown.961fb9f4d4fe5a0823bd1fe4b3cd2e13.svg";
export { ForwardRef as ReactComponent };